import React from 'react';
import styles from './DealStatus.module.scss';
import { Card, CardContent } from '@material-ui/core';
import DealStatusChart from './chart/DealStatusChart';

const DealStatus = ({ salesAgentId, filterByDate }) => {
	return (
		// <div className={styles.deal_status_card_group}>
		// </div>
		<Card className={styles.deal_status_card_group} variant='outlined'>
			<CardContent>
				<div className={styles.card_title}>Deal Status</div>
				<DealStatusChart
					salesAgentId={salesAgentId}
					filterByDate={filterByDate}
				/>
			</CardContent>
		</Card>
	);
};

export default DealStatus;
